import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

import Sidebar from "../components/Sidebar";

export default function BeneficiaryManagement() {
  const navigate = useNavigate();

  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ total: 0, family: 0, individual: 0 });

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Payment states
  const [paymentMethod, setPaymentMethod] = useState("RAZORPAY");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentDescription, setPaymentDescription] = useState("");

  // Household members state
  const [householdMembers, setHouseholdMembers] = useState([]);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [memberForm, setMemberForm] = useState({
    name: "",
    age: "",
    relation: "",
    gender: "",
    photo: null
  });
  const [memberPhotoPreview, setMemberPhotoPreview] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    beneficiaryId: "",
    headName: "",
    age: "",
    village: "",
    fullAddress: "",
    cardType: "INDIVIDUAL",
    gender: "",
    mobile: "",
    pinCode: "",
    photo: null
  });
  const [photoPreview, setPhotoPreview] = useState(null);

  const userEmail = localStorage.getItem("userEmail") || localStorage.getItem("LOGGED_USER") || localStorage.getItem("email");
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "ADMIN" || userRole === "Admin";

  useEffect(() => {
    loadBeneficiaries();
  }, []);


const [currentPage, setCurrentPage] = useState(0);
const [pageSize, setPageSize] = useState(10);
const [totalPages, setTotalPages] = useState(0);
const [totalElements, setTotalElements] = useState(0);
  // const loadBeneficiaries = async () => {
  //   setLoading(true);
  //   try {
  //     const email = localStorage.getItem("LOGGED_USER");
  //     const res = await api.get(`/beneficiary/list2?email=${email}`);
  //     const list = res.data || [];
  //     setBeneficiaries(list);
  //     setStats({
  //       total: list.length,
  //       family: list.filter(b => b.cardType === "FAMILY").length,
  //       individual: list.filter(b => b.cardType === "INDIVIDUAL").length
  //     });
  //   } catch (err) {
  //     console.error("Failed to load beneficiaries", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const loadBeneficiaries = async (page = currentPage, size = pageSize) => {
  setLoading(true);

  try {
    const email = localStorage.getItem("LOGGED_USER");

    const res = await api.get(
      `/beneficiary/list3?email=${encodeURIComponent(email)}&page=${page}&size=${size}`
    );

    const data = res.data;

    setBeneficiaries(data.content || []);

    setCurrentPage(data.currentPage || 0);
    setTotalPages(data.totalPages || 0);
    setTotalElements(data.totalElements || 0);

    // Stats for current page only
    const list = data.content || [];

    setStats({
      total: data.totalElements || 0,
      family: list.filter(
        b => b.cardType === "FAMILY"
      ).length,
      individual: list.filter(
        b => b.cardType === "INDIVIDUAL"
      ).length
    });

  } catch (err) {
    console.error("Failed to load beneficiaries", err);
  } finally {
    setLoading(false);
  }
};
  const generateBeneficiaryId = async () => {
    try {
      const res = await api.get("/beneficiary/generate-id");
      setFormData(prev => ({ ...prev, beneficiaryId: res.data }));
    } catch (err) {
      console.error("Failed to generate ID:", err);
    }
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let base64String = reader.result;
        if (base64String.includes(',')) {
          base64String = base64String.split(',')[1];
        }
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const openAddModal = () => {
    setModalTitle("Add New Beneficiary");
    setEditingId(null);
    setFormData({
      beneficiaryId: "",
      headName: "",
      age: "",
      village: "",
      fullAddress: "",
      cardType: "INDIVIDUAL",
      gender: "",
      mobile: "",
      pinCode: "",
      photo: null
    });
    setPhotoPreview(null);
    setHouseholdMembers([]);
    // Set payment amount based on card type
    const amount = formData.cardType === "FAMILY" ? 200 : 80;
    setPaymentAmount(amount.toString());
    generateBeneficiaryId();
    setShowModal(true);
  };

  const openEditModal = (beneficiary) => {
    setModalTitle("Edit Beneficiary");
    setEditingId(beneficiary.id);
    setFormData({
      beneficiaryId: beneficiary.beneficiaryId,
      headName: beneficiary.headName,
      age: beneficiary.age,
      village: beneficiary.village,
      fullAddress: beneficiary.fullAddress,
      cardType: beneficiary.cardType,
      gender: beneficiary.gender,
      mobile: beneficiary.mobile,
      pinCode: beneficiary.pinCode,
      photo: null
    });
    setPhotoPreview(beneficiary.photo ? `data:image/jpeg;base64,${beneficiary.photo}` : null);
    
    if (beneficiary.id) {
      loadHouseholdMembers(beneficiary.id);
    } else {
      setHouseholdMembers([]);
    }
    setShowModal(true);
  };

  const loadHouseholdMembers = async (beneficiaryId) => {
    try {
      const res = await api.get(`/beneficiary/${beneficiaryId}/household`);
      setHouseholdMembers(res.data);
    } catch (err) {
      console.error("Failed to load household members", err);
      setHouseholdMembers([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData(prev => ({ ...prev, photo: file }));
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setPhotoPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setPhotoPreview(null);
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
      // Update payment amount when card type changes
      if (name === "cardType") {
        const amount = value === "FAMILY" ? 200 : 80;
        setPaymentAmount(amount.toString());
      }
    }
  };

  const handleMemberChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setMemberForm({ ...memberForm, photo: file });
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setMemberPhotoPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setMemberPhotoPreview(null);
      }
    } else {
      setMemberForm({ ...memberForm, [name]: value });
    }
  };

  const openMemberModal = (member = null) => {
    if (formData.cardType === "INDIVIDUAL") {
      alert("Individual card holders cannot add household members.");
      return;
    }
    
    if (!member && householdMembers.length >= 3) {
      alert("Maximum 3 household members allowed for Family Card.");
      return;
    }
    
    if (member) {
      setEditingMember(member);
      setMemberForm({
        name: member.name,
        age: member.age,
        relation: member.relation,
        gender: member.gender,
        photo: null
      });
      setMemberPhotoPreview(member.photo ? `data:image/jpeg;base64,${member.photo}` : null);
    } else {
      setEditingMember(null);
      setMemberForm({ name: "", age: "", relation: "", gender: "", photo: null });
      setMemberPhotoPreview(null);
    }
    setShowMemberForm(true);
  };

  const saveMember = () => {
    if (!memberForm.name || !memberForm.age || !memberForm.relation || !memberForm.gender) {
      alert("All fields are required");
      return;
    }
    
    if (editingMember) {
      setHouseholdMembers(prev => prev.map(m => 
        m.id === editingMember.id 
          ? { ...m, ...memberForm, photo: memberForm.photo || m.photo }
          : m
      ));
      alert("Member updated successfully!");
    } else {
      const newMember = {
        id: Date.now(),
        ...memberForm,
        photo: memberForm.photo || null
      };
      setHouseholdMembers(prev => [...prev, newMember]);
      alert("Member added successfully!");
    }
    
    setShowMemberForm(false);
    setEditingMember(null);
    setMemberForm({ name: "", age: "", relation: "", gender: "", photo: null });
    setMemberPhotoPreview(null);
  };

  const deleteMember = (memberId) => {
    if (window.confirm("Delete this household member?")) {
      setHouseholdMembers(prev => prev.filter(m => m.id !== memberId));
      alert("Member deleted");
    }
  };

  const validateForm = () => {
    if (!formData.headName.trim()) return "Head Name is required";
    const ageNum = parseInt(formData.age);
    if (isNaN(ageNum) || ageNum < 1 || ageNum > 119) return "Age must be 1–119";
    if (!formData.village.trim()) return "Village is required";
    if (!formData.fullAddress.trim()) return "Full Address is required";
    if (!formData.gender) return "Gender is required";
    if (!/^[0-9]{10}$/.test(formData.mobile)) return "Mobile must be 10 digits";
    if (!/^[0-9]{6}$/.test(formData.pinCode)) return "PIN Code must be 6 digits";
    return null;
  };

  // Save beneficiary function
  const saveBeneficiary = async () => {
    try {
      let photoBase64 = null;
      if (formData.photo) {
        photoBase64 = await convertFileToBase64(formData.photo);
      }
      
      const membersWithPhotos = await Promise.all(householdMembers.map(async (member) => {
        let memberPhotoBase64 = null;
        if (member.photo && typeof member.photo !== 'string') {
          try {
            memberPhotoBase64 = await convertFileToBase64(member.photo);
          } catch (error) {
            console.error("Error converting member photo:", error);
          }
        } else if (member.photo && typeof member.photo === 'string') {
          memberPhotoBase64 = member.photo;
        }
        return {
          name: member.name,
          age: parseInt(member.age),
          relation: member.relation,
          gender: member.gender,
          photo: memberPhotoBase64
        };
      }));
      
      const requestData = {
        headName: formData.headName,
        age: parseInt(formData.age),
        village: formData.village,
        fullAddress: formData.fullAddress,
        cardType: formData.cardType,
        gender: formData.gender,
        mobile: formData.mobile,
        pinCode: formData.pinCode,
        createdBy: userEmail,
        beneficiaryId: formData.beneficiaryId,
        photo: photoBase64,
        householdMembers: membersWithPhotos,
        paymentAmount: parseFloat(paymentAmount),
        paymentDescription: paymentDescription || `Payment for ${formData.cardType === "FAMILY" ? "Family" : "Individual"} card`,
        paymentMethod: "RAZORPAY",
        paymentStatus: "PAID"
        

      };
      
      const userEmailForRequest = localStorage.getItem("LOGGED_USER");
      const finalRequestData = { ...requestData, createdBy: userEmailForRequest };
      
      if (editingId) {
       const formData = new FormData();

formData.append("headName", requestData.headName);
formData.append("age", requestData.age);
formData.append("village", requestData.village);
formData.append("fullAddress", requestData.fullAddress);
formData.append("cardType", requestData.cardType);
formData.append("gender", requestData.gender);
formData.append("mobile", requestData.mobile);
formData.append("pinCode", requestData.pinCode);

formData.append("districtId", requestData.districtId);
formData.append("blockId", requestData.blockId);
formData.append("gpId", requestData.gpId);

if (formData.photo) {
    formData.append("photo", formData.photo);
}


await api.put(
    `/beneficiary/update/${editingId}`,
    formData
);
        alert("Beneficiary updated successfully!");
      } else {
        await api.post("/beneficiary/save-with-members", finalRequestData, {
          headers: { "Content-Type": "application/json" }
        });
        alert("Beneficiary added successfully!");
      }

      setShowModal(false);
      loadBeneficiaries();
      
    } catch (err) {
      console.error("Save error:", err);
      throw err;
    }
  };

  // Razorpay payment handler
  const handleRazorpayPayment = async () => {
    // Validate form first
    const error = validateForm();
    if (error) {
      alert(error);
      return;
    }

    const amountNum = parseFloat(paymentAmount);
    if (isNaN(amountNum) || amountNum <= 0) {
      alert("Please enter valid payment amount");
      return;
    }

    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      alert("Razorpay SDK failed to load");
      return;
    }

    setSubmitLoading(true);

    try {
      // Create order from backend
      const orderRes = await api.post("/payments/registration/init", {
        amount: amountNum,
        description: paymentDescription || `Beneficiary registration fee for ${formData.headName}`,
        paymentMethod: "RAZORPAY",
        beneficiaryData: {
          name: formData.headName,
          mobile: formData.mobile,
          cardType: formData.cardType
        }
      });

      const options = {
        key: "rzp_live_T2zVuDM09kAR4w",
        amount: orderRes.data.amount,
        currency: orderRes.data.currency,
        name: "RHCWF - Beneficiary Registration",
        description: paymentDescription || `Payment for ${formData.cardType === "FAMILY" ? "Family" : "Individual"} Card`,
        order_id: orderRes.data.orderId,


//       handler: async function (response){
//   try {

//     console.log("=== RAZORPAY SUCCESS ===");
//     console.log("Order ID:", response.razorpay_order_id);
//     console.log("Payment ID:", response.razorpay_payment_id);
//     console.log("Signature:", response.razorpay_signature);

//     const verifyRes = await api.post("/payments/razorpay-verify", {
//       razorpayOrderId: response.razorpay_order_id,
//       razorpayPaymentId: response.razorpay_payment_id,
//       razorpaySignature: response.razorpay_signature
//     });

//     console.log("Verification Response:", verifyRes.data);

//     await saveBeneficiary();

//     alert("✅ Payment successful and beneficiary created!");

//   } catch (err) {

//     console.error("Verification Error:", err);

//     if (err.response) {
//       console.log("Status:", err.response.status);
//       console.log("Data:", err.response.data);
//     }

//     alert("Payment done but verification failed.");
//   }
// },
        
handler: async function (response) {
 // let verified = false;
  try {
    
    const verifyRes = await api.post("/payments/razorpay-verify", {
      razorpayOrderId: response.razorpay_order_id,
      razorpayPaymentId: response.razorpay_payment_id,
      razorpaySignature: response.razorpay_signature
    });
    console.log("Verification Response:", verifyRes.data);
   // verified = true;
  } catch (err) {
    console.error("Verification Error:", err);
    alert("❌ Payment verification failed. Please contact support with Payment ID: " + response.razorpay_payment_id);
    return; // stop here — don't attempt to save
  }

  // Separate try — now we KNOW verification succeeded
  try {
   await saveBeneficiary(response);
    alert("✅ Payment successful and beneficiary created!");
  } catch (err) {
    console.error("Save beneficiary error:", err);
    alert(
      "⚠️ Payment was verified successfully (Payment ID: " + response.razorpay_payment_id + 
      "), but saving the beneficiary failed: " + (err.response?.data || err.message) +
      "\nPlease retry saving or contact support — do NOT pay again."
    );
  }
},prefill: {
          name: formData.headName,
          contact: formData.mobile
        },
        theme: {
          color: "#1a472a"
        },
        modal: {
          ondismiss: () => {
            setSubmitLoading(false);
            alert("Payment cancelled. Beneficiary not created.");
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error("Razorpay payment error:", err);
      alert(err.response?.data?.message || "Unable to start Razorpay payment");
    } finally {
      setSubmitLoading(false);
    }
  };

  // Final create handler
  const handleFinalCreate = async () => {
    await handleRazorpayPayment();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this beneficiary?")) return;
    try {
      await api.delete(`/beneficiary/delete/${id}`);
      alert("Deleted successfully");
      loadBeneficiaries();
    } catch (err) {
      alert("Delete failed. Please try again.");
    }
  };

  const isFamilyCard = formData.cardType === "FAMILY";

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-title">
            <h1>Beneficiary Management</h1>
            <p>{userRole === "GP_COORDINATOR" ? `Your beneficiaries — ${userEmail}` : "All beneficiaries"}</p>
          </div>
          <div className="header-date">
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long', year: 'numeric',
              month: 'long', day: 'numeric'
            })}
          </div>
        </div>

        <div className="stats-container">
          <StatCard title="Total Beneficiaries" value={stats.total} icon="👥" color="#3b82f6" bgColor="#dbeafe" />
          <StatCard title="Family Cards" value={stats.family} icon="👪" color="#10b981" bgColor="#d1fae5" />
          <StatCard title="Individual Cards" value={stats.individual} icon="👤" color="#f59e0b" bgColor="#fed7aa" />
        </div>

        <div className="revenue-card">
          <div className="section-header" style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <h2>Beneficiaries</h2>
              <p>List of all registered beneficiaries</p>
            </div>
     {!isAdmin && (
  <button
    className="export-excel-btn"
    onClick={openAddModal}
  >
    ➕ Add Beneficiary
  </button>
)}

          </div>

          {loading ? (
            <div className="loading-spinner">Loading...</div>
         ) : beneficiaries.length > 0 ? (
  <>
    <table className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Beneficiary ID</th>
                  <th>Head Name</th>
                  <th>Village</th>
                  <th>Mobile</th>
                  {/* <th>Photo</th> */}
                  <th>Card Type</th>
                  <th>Card Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {beneficiaries.map((item, idx) => (
                  <tr key={item.id || idx}>
                    <td>{idx + 1}</td>
                    <td>{item.beneficiaryId}</td>
                    <td>{item.headName}</td>
                    <td>{item.village}</td>
                    <td>{item.mobile}</td>
                    {/* <td>
                      {item.photo ? (
                        <img src={`data:image/jpeg;base64,${item.photo}`} alt={item.headName} style={{ width:"45px", height:"45px", objectFit:"cover", borderRadius:"6px" }} />
                      ) : (
                        <span style={{ fontSize:"22px" }}>📷</span>
                      )}
                    </td> */}
                    <td>{item.cardType === "FAMILY" ? "Family Card" : "Individual Card"}</td>
                    <td>
                      <span style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        background: item.cardIssued ? "#d1fae5" : "#fee2e2",
                        color: item.cardIssued ? "#065f46" : "#991b1b",
                        padding: "5px 12px",
                        borderRadius: "999px",
                        fontSize: "12px",
                        fontWeight: "700"
                      }}>
                        {item.cardIssued ? "✔ ISSUED" : "✖ NOT ISSUED"}
                      </span>
                    </td>
                    <td>
                      <button className="edit-member-btn" onClick={() => navigate(`/beneficiary/${item.id}`)} style={{ marginRight:"6px", background:"#3b82f6" }}>View</button>
                      {isAdmin && (
                        <>
                          <button className="edit-member-btn" onClick={() => openEditModal(item)} style={{ marginRight: "6px" }}>Edit</button>
                          <button className="edit-member-btn" onClick={() => handleDelete(item.id)} style={{ background: "#ef4444" }}>Delete</button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          {totalElements > 0 && (
  <div className="pagination-footer">

    <div className="pagination-info">
      Showing{" "}
      <strong>{currentPage * pageSize + 1}</strong>
      {" – "}
      <strong>
        {Math.min(
          (currentPage + 1) * pageSize,
          totalElements
        )}
      </strong>
      {" of "}
      <strong>{totalElements}</strong>
      {" beneficiaries"}
    </div>

    <div className="pagination-controls">

      <span className="rows-label">
        Rows per page
      </span>

      <select
        value={pageSize}
        onChange={(e) => {
          const newSize = Number(e.target.value);

          setPageSize(newSize);
          setCurrentPage(0);
          loadBeneficiaries(0, newSize);
        }}
        className="page-size-select"
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>

      <button
        className="pagination-btn"
        disabled={currentPage === 0 || loading}
        onClick={() =>
          loadBeneficiaries(currentPage - 1, pageSize)
        }
      >
        ‹
      </button>

      {Array.from(
        { length: totalPages },
        (_, index) => index
      ).map((page) => (
        <button
          key={page}
          className={`pagination-number ${
            currentPage === page ? "active" : ""
          }`}
          disabled={loading}
          onClick={() =>
            loadBeneficiaries(page, pageSize)
          }
        >
          {page + 1}
        </button>
      ))}

      <button
        className="pagination-btn"
        disabled={
          currentPage === totalPages - 1 || loading
        }
        onClick={() =>
          loadBeneficiaries(currentPage + 1, pageSize)
        }
      >
        ›
      </button>

    </div>
  </div>
)}
  </>
          ) : (
            <div className="no-data">No beneficiaries found.</div>
          )}
        </div>

        {/* Add/Edit Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-container edit-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: "800px", maxHeight: "90vh", overflowY: "auto" }}>
              <div className="modal-header">
                <h3>{modalTitle}</h3>
                <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
              </div>
              <div className="modal-body edit-modal-body">
                <form className="edit-form">
                  <div className="form-section">
                    <h4>Beneficiary Information</h4>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Beneficiary ID</label>
                        <input value={formData.beneficiaryId} disabled style={{ background:"#f3f4f6" }} />
                      </div>
                      <div className="form-group">
                        <label>Head Name *</label>
                        <input name="headName" value={formData.headName} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Age * (1–119)</label>
                        <input type="number" name="age" min="1" max="119" value={formData.age} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label>Village *</label>
                        <input name="village" value={formData.village} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Full Address *</label>
                      <textarea name="fullAddress" rows="2" value={formData.fullAddress} onChange={handleChange} required />
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Card Type</label>
                        <select name="cardType" value={formData.cardType} onChange={handleChange}>
                          <option value="INDIVIDUAL">Individual Card (₹80) - No Extra Members</option>
                          <option value="FAMILY">Family Card (₹200) - Up to 3 Members</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Gender *</label>
                        <select name="gender" value={formData.gender} onChange={handleChange} required>
                          <option value="">Select</option>
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                          <option value="OTHER">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Mobile * (10 digits)</label>
                        <input type="tel" name="mobile" pattern="[0-9]{10}" value={formData.mobile} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label>PIN Code * (6 digits)</label>
                        <input name="pinCode" pattern="[0-9]{6}" value={formData.pinCode} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Photo (Optional)</label>
                      <input type="file" accept="image/*" onChange={handleChange} />
                      {photoPreview && (
                        <img src={photoPreview} alt="Preview" style={{ marginTop:"8px", width:"90px", borderRadius:"8px" }} />
                      )}
                    </div>
                  </div>
                  
                  {/* Payment Section */}
                  <div className="form-section" style={{ marginTop: "20px", borderTop: "2px solid #e5e7eb", paddingTop: "20px" }}>
                    <h4>💰 Payment Details</h4>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Amount (₹)</label>
                        <input
                          type="number"
                          value={paymentAmount}
                          disabled
                          style={{ background: "#f3f4f6" }}
                        />
                      </div>
                      <div className="form-group">
                        <label>Description (optional)</label>
                        <input
                          type="text"
                          value={paymentDescription}
                          onChange={(e) => setPaymentDescription(e.target.value)}
                          placeholder="e.g., Registration fee"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Payment Method</label>
                      <select value={paymentMethod} disabled style={{ background: "#f3f4f6" }}>
                        <option value="RAZORPAY">💳 Razorpay Online Payment</option>
                      </select>
                    </div>
                    <div className="info-box" style={{ background: "#e0f2fe", padding: "12px", borderRadius: "8px", marginTop: "10px" }}>
                      <p style={{ margin: 0, fontSize: "13px" }}>
                        🔒 <strong>Razorpay Payment:</strong> You will be redirected to Razorpay payment gateway. 
                        Beneficiary will be created only after successful payment verification.
                      </p>
                    </div>
                  </div>

                  {isFamilyCard && (
                    <div className="household-members-section" style={{ marginTop: "20px", borderTop: "2px solid #e5e7eb", paddingTop: "20px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                        <h4>👨‍👩‍👧‍👦 Household Members ({householdMembers.length} / 3)</h4>
                        {householdMembers.length < 3 && (
                          <button type="button" className="btn-secondary" onClick={() => openMemberModal()} style={{ padding: "6px 12px", fontSize: "12px" }}>
                            ➕ Add Member
                          </button>
                        )}
                      </div>
                      {householdMembers.length === 0 ? (
                        <div className="no-data" style={{ padding: "20px", textAlign: "center", background: "#f9fafb", borderRadius: "8px" }}>
                          <span style={{ fontSize: "32px" }}>👨‍👩‍👧</span>
                          <p style={{ marginTop: "10px" }}>No members added yet. Click "Add Member" to add family members.</p>
                          <p style={{ fontSize: "12px", color: "#666" }}>Maximum 3 household members allowed for Family Card.</p>
                        </div>
                      ) : (
                        <table className="data-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr style={{ background: "#f3f4f6" }}>
                              <th style={{ padding: "10px", textAlign: "left" }}>#</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Photo</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Name</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Age</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Relation</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Gender</th>
                              <th style={{ padding: "10px", textAlign: "left" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {householdMembers.map((member, idx) => (
                              <tr key={member.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                                <td style={{ padding: "10px" }}>{idx + 1}</td>
                                <td style={{ padding: "10px" }}>
                                  {member.photo ? (
                                    <img 
                                      src={typeof member.photo === 'string' ? `data:image/jpeg;base64,${member.photo}` : URL.createObjectURL(member.photo)}
                                      alt={member.name}
                                      style={{ width: "40px", height: "40px", borderRadius: "20px", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <span style={{ fontSize: "24px" }}>👤</span>
                                  )}
                                </td>
                                <td style={{ padding: "10px" }}>{member.name}</td>
                                <td style={{ padding: "10px" }}>{member.age}</td>
                                <td style={{ padding: "10px" }}>{member.relation}</td>
                                <td style={{ padding: "10px" }}>{member.gender}</td>
                                <td style={{ padding: "10px" }}>
                                  <button type="button" className="edit-member-btn" onClick={() => openMemberModal(member)} style={{ marginRight: "5px" }}>
                                    ✏️ Edit
                                  </button>
                                  <button type="button" className="edit-member-btn" onClick={() => deleteMember(member.id)} style={{ background: "#ef4444" }}>
                                    🗑️ Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                      {householdMembers.length >= 3 && (
                        <p style={{ textAlign: "center", color: "#f59e0b", marginTop: "10px", fontSize: "12px" }}>
                          ⚠️ Maximum 3 household members reached for Family Card
                        </p>
                      )}
                    </div>
                  )}
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
               <button
    className="btn-submit"
    onClick={editingId ? saveBeneficiary : handleFinalCreate}
    disabled={submitLoading}
>
    {submitLoading
        ? "Processing..."
        : editingId
            ? "💾 Save Changes"
            : "💳 Pay with Razorpay & Create Beneficiary"}
</button>

 {/* <button
                  className="btn-submit"
                  onClick={handleFinalCreate}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Processing..." : "💳 Pay with Razorpay & Create Beneficiary"}
                </button> */}
              </div>
            </div>
          </div>
        )}

        {/* Member Add/Edit Modal */}
        {showMemberForm && (
          <div className="modal-overlay" onClick={() => setShowMemberForm(false)}>
            <div className="modal-container edit-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
              <div className="modal-header">
                <h3>{editingMember ? "Edit Household Member" : "Add Household Member"}</h3>
                <button className="modal-close" onClick={() => setShowMemberForm(false)}>×</button>
              </div>
              <div className="modal-body edit-modal-body">
                <form className="edit-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Profile Photo</label>
                      <input type="file" name="photo" accept="image/*" onChange={handleMemberChange} />
                      {memberPhotoPreview && (
                        <img 
                          src={memberPhotoPreview} 
                          alt="Preview" 
                          style={{ marginTop: "8px", width: "80px", height: "80px", borderRadius: "40px", objectFit: "cover" }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Name *</label>
                      <input type="text" name="name" value={memberForm.name} onChange={handleMemberChange} required />
                    </div>
                    <div className="form-group">
                      <label>Age *</label>
                      <input type="number" name="age" min="0" max="120" value={memberForm.age} onChange={handleMemberChange} required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relation *</label>
                      <select name="relation" value={memberForm.relation} onChange={handleMemberChange} required>
                        <option value="">Select Relation</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Husband">Husband</option>
                        <option value="Wife">Wife</option>
                        <option value="Daughter">Daughter</option>
                        <option value="Son">Son</option>
                        <option value="Brother">Brother</option>
                        <option value="Sister">Sister</option>
                        <option value="Uncle">Uncle</option>
                        <option value="Aunty">Aunty</option>
                        <option value="Grandfather">Grandfather</option>
                        <option value="Grandmother">Grandmother</option>
                        <option value="Father-in-law">Father-in-law</option>
                        <option value="Mother-in-law">Mother-in-law</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Gender *</label>
                      <select name="gender" value={memberForm.gender} onChange={handleMemberChange} required>
                        <option value="">Select</option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                        <option value="OTHER">Other</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn-secondary" onClick={() => setShowMemberForm(false)}>Cancel</button>
                <button className="btn-save" onClick={saveMember}>
                  Save Member
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function StatCard({ title, value, icon, color, bgColor }) {
  return (
    <div className="stat-card">
      <div className="stat-card-icon" style={{ backgroundColor: bgColor, color }}>
        {icon}
      </div>
      <div className="stat-card-info">
        <h4>{title}</h4>
        <p>{value}</p>
      </div>
    </div>
  );
}